import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../services/AuthContext";
import { Footer2 } from "../footer2/index";
import Header from "../header";
import InstructorSidebar from "./sidebar";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../services/axiosInstance";
import SavedTab from "./savedTab";
import SavedPublications from "./savedTab/savedpublications";
import SavedSearch from "./savedTab/savedSearch";
import { Helmet } from "react-helmet-async";

// Kayıt tarihini Türkçe formatlamak için yardımcı fonksiyon
function formatDateTR(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date)) return '';
  return date.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

const Profile = () => {
  const { auth } = useContext(AppContext);
  const [profile, setProfile] = useState(auth);
  const [activeTab, setActiveTab] = useState('profile');
  const [favorites, setFavorites] = useState([]);
  const [loadingFavorites, setLoadingFavorites] = useState(false);
  const [favError, setFavError] = useState(null);
  const [favoritesTab, setFavoritesTab] = useState('publications'); // 'publications' veya 'searches'
  const navigate = useNavigate();

  // Auth guard
  useEffect(() => {
    if (!auth || !auth.token) {
      navigate('/login');
    }
  }, [auth, navigate]);

  useEffect(() => {
    setProfile(auth);
  }, [auth]);

  // // Favori yayınları çek
  // useEffect(() => {
  //   if (activeTab === 'favorites' && auth && auth.token) {
  //     setLoadingFavorites(true);
  //     setFavError(null);
  //     axiosInstance.get(`userpanel/favoritepublicationsListByUserId/1`, {
  //       headers: {
  //         Authorization: `Bearer ${auth.token}`
  //       }
  //     })
  //       .then(res => {
  //         setFavorites(res.data.data || []);
  //       })
  //       .catch(() => {
  //         setFavError('Kaydedilenler alınamadı.');
  //       })
  //       .finally(() => setLoadingFavorites(false));
  //   }
  // }, [activeTab, auth]);

  return (
    <div className="d-flex flex-column min-vh-100 bg-body-tertiary">
          <Helmet>
              <title>İdealonline - Profil</title>
            </Helmet>
      <Header activeMenu={"Profil"} />
      <main className="flex-grow-1">
        <div className="container py-5 mt-5">
          <h2 className="text-center fw-bold mb-5 text-newdarkfume">Profil</h2>
          <div className="row justify-content-center">
            {/* Sol Profil Kartı */}
            <div className="col-lg-4 mb-4">
              <InstructorSidebar />
            </div>
            {/* Sağ Profil Bilgileri ve Kaydedilenler */}
            <div className="col-lg-8">
              <div className="bg-white rounded-4 shadow-sm p-4">
                {/* Tablar */}
                <ul className="nav nav-tabs mb-4">
                  <li className="nav-item">
                    <button
                      className="nav-link active fs-6 px-4 py-2"
                      style={{ cursor: "default" }}
                      disabled
                    >
                      Profil Bilgileri
                    </button>
                  </li>
                </ul>

                {/* Tab İçerikleri */}
                {activeTab === 'profile' && (
                  <div>
                    <h4 className="fw-bold mb-4 text-newdarkfume border-bottom pb-2">Profil Bilgileri</h4>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="text-darkfume fw-semibold text-sm small">Ad</div>
                        <div className="text-fume">{profile.name}</div>
                      </div>
                      <div className="col-md-6">
                        <div className="text-darkfume small fw-semibold text-sm">Soyad</div>
                        <div className="text-fume">{profile.surname}</div>
                      </div>
                      <div className="col-md-6">
                        <div className="text-darkfume small fw-semibold text-sm">Kullanıcı Adı</div>
                        <div className="text-fume">{profile.email}</div>
                      </div>
                      <div className="col-md-6">
                        <div className="text-darkfume small fw-semibold text-sm">Telefon Numarası</div>
                        <div className="text-fume">{profile.telephone}</div>
                      </div>
                      {/* Diğer bilgiler eklenebilir */}
                    </div>
                  </div>
                )}  
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer2 />
    </div>
  );
};

export default Profile;